import devConfig from "./config.local.json";
import prodConfig from "./config.prod.json";

const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

let config;
if (process.env.NODE_ENV === "development") {
  config = isLocalhost ? devConfig : prodConfig;
} else {
  config = prodConfig;
}

// Debug log
console.log("[CONFIG] NODE_ENV:", process.env.NODE_ENV);
console.log(
  "[CONFIG] Hostname:",
  typeof window !== "undefined" ? window.location.hostname : "server"
);
console.log("[CONFIG] Using config:", config);
export default config;
